// extracted by mini-css-extract-plugin
export default {"cover":"Profile_cover__1AEp2","name":"Profile_name__8zRjk","email":"Profile_email__N13Q-"};